var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 7.5C24.4688 7.5 25.5 8.53125 25.5 9.75V23.25C25.5 24.5156 24.4688 25.5 23.25 25.5H21.75C20.4844 25.5 19.5 24.5156 19.5 23.25V9.75C19.5 8.53125 20.4844 7.5 21.75 7.5H23.25ZM8.25 13.5C9.46875 13.5 10.5 14.5312 10.5 15.75V23.25C10.5 24.5156 9.46875 25.5 8.25 25.5H6.75C5.48438 25.5 4.5 24.5156 4.5 23.25V15.75C4.5 14.5312 5.48438 13.5 6.75 13.5H8.25Z",
    fill: "#465DD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 6.75C12 5.53125 12.9844 4.5 14.25 4.5H15.75C16.9688 4.5 18 5.53125 18 6.75V23.25C18 24.5156 16.9688 25.5 15.75 25.5H14.25C12.9844 25.5 12 24.5156 12 23.25V6.75Z",
    fill: "#465DD8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertical);
export default __webpack_public_path__ + "static/media/vertical.61950774.svg";
export { ForwardRef as ReactComponent };